<div class="nav-logo">
  <img
    src="../../../assets/LMAX-Exchange-horizontal-logo.svg"
    alt="FXHP Logo"
  />
</div>
<div
  *ngIf="(isFXHPAdmin || isFXHPViewer || isFXHPRiskManager) && showIsProd"
  class="environment-name-container environment-name-container-prod"
>
  <span>{{ environmentName }}</span>
</div>
<div
  *ngIf="(isFXHPAdmin || isFXHPViewer || isFXHPRiskManager) && !showIsProd"
  class="environment-name-container environment-name-container-non-prod"
>
  <span [class.smaller-env-name-font]="environmentName.length > 5">{{
    environmentName | slice: 0 : 7
  }}</span>
</div>
<nav-links
  [accessibility]="accessibility"
  [isFXHPAdmin]="isFXHPAdmin"
  [isFXHPViewer]="isFXHPViewer"
  [isFXHPRiskManager]="isFXHPRiskManager"
  [hasAuditAccess]="hasAuditAccess"
  [isBlotterTrader]="isBlotterTrader"
  [isFixingOrderTrader]="isFixingOrderTrader"
  [isCreditBank]="isCreditBank"
  [isCreditRiskManager]="isCreditRiskManager"
></nav-links>
<div class="router-outlet">
  <!-- This is the top bar -->
  <div class="custom-top-bar">
    <div class="top-bar-button-group">
      <!--Party Selector for top bar-->
      <party-selector
        class="party-selector"
        [class.party-select-admin-user]="
          isFXHPViewer || isFXHPAdmin || isFXHPRiskManager
        "
      ></party-selector>
      <!--Top Bar Buttons-->
      <div class="nav-button-wrapper">
        <button
          mat-icon-button
          data-cy="user-profile"
          matTooltip="User Profile"
          class="menu-button"
          aria-label="Help"
          [matMenuTriggerFor]="profileMenu"
        >
          <span class="user-initials">{{ userInitials }}</span>
        </button>
      </div>

      <!-- Profile Menu-->
      <mat-menu
        #profileMenu="matMenu"
        class="profile-menu-content"
        data-cy="profile-menu"
      >
        <div class="profile-menu-wrapper">
          <section>
            <div class="user-details">
              <h2>{{ userName }}</h2>
              <p>{{ entityName }} | {{ rolesDisplayString }}</p>
              <p>User Since {{ createdAt | date }}</p>
            </div>
          </section>
          <section>
            <div class="profile-options-wrapper">
              <div class="profile-options">
                <mat-icon
                  class="profile-icon"
                  fontSet="material-symbols-outlined"
                  >contact_support</mat-icon
                >
                <a href="mailto:exchange.support@lmax.com"
                  >exchange.support&#64;lmax.com</a
                >
              </div>
              <div class="profile-options">
                <mat-icon
                  class="profile-icon"
                  fontSet="material-symbols-outlined"
                  >memory</mat-icon
                >
                <p>{{ localLastUpdated }} (Build: {{ localBuildNumber }})</p>
              </div>
            </div>
          </section>
          <section>
            <div class="profile-options-wrapper" style="cursor: pointer">
              <div
                class="profile-options"
                style="cursor: pointer"
                (click)="openLogOutDialog()"
              >
                <mat-icon
                  data-cy="logout-user"
                  class="profile-icon"
                  fontSet="material-symbols-outlined"
                  >exit_to_app</mat-icon
                >
                <p>Log Out</p>
              </div>
            </div>
          </section>
        </div>
      </mat-menu>
    </div>
  </div>

  <!-- This is the main page -->
  <main
    class="page-container"
    [class.theme--accessibility]="accessibility === true"
    [class.theme--default]="accessibility === false"
  >
    <mat-card class="main-app-card">
      <router-outlet></router-outlet>
    </mat-card>
  </main>

  <div *ngIf="showAccessibilityButton" class="accessibility-toggle">
    <button
      mat-icon-button
      color="primary"
      class="accessibility-button"
      data-cy="accessibility-button"
      (click)="setTheme()"
    >
      <mat-icon fontSet="material-symbols">accessibility_new</mat-icon>
    </button>
  </div>
</div>
